<mat-icon [matMenuTriggerFor]="menu" class="layout-icon" [matTooltip]="tooltipLabel">dashboard</mat-icon>
<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="onClick(0)">
    <mat-icon [style.visibility]="selectedFlags[0]?'visible':'hidden'">done</mat-icon>
    {{ defaultLayoutLabel }}
  </button>
  <mat-divider></mat-divider>
  @for (config of configurations; track config; let i = $index) {
    <button mat-menu-item (click)="onClick(config.id)">
      <mat-icon [style.visibility]="selectedFlags[i+1]?'visible':'hidden'">done</mat-icon>
      {{ config.name }}
    </button>
  }
</mat-menu>
